import { FilledInput } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import Tooltip from '@mui/material/Tooltip';
import { GroupChatGrey, NewGroupChatMessageIcon, NewMessageIcon2, NewMessageIconNew, SearchButtonClearIcon, SearchIcon } from '../../icon';
import { useState } from 'react';
import * as selector from "../../selectors/selectors";
import { useSelector } from 'react-redux';
import { PlanMetrics } from '../../models/plan-metrics.model';
import { UserPlanTracker } from '../../models/plan-metrics.model';

interface Props {
    IsMobileDevice: boolean
    handleSearch: (value: string) => void
    OnClickNewMessage: () => void;
    OnClickNewGroupMessage: () => void;
    OnClickNewCampaignMessage: () => void;
    openSendMessage: boolean;
    SecureChat: boolean;
}

const ConversationHeader = (props: Props) => {
    const PlanMetrics: PlanMetrics = useSelector(selector.planMetrics);
    const IsDarkMode: boolean = useSelector(selector.isDarkMode);
    const IsNewOrgFlow: boolean = useSelector(selector.isNewOrgFlow);
    const userPlanTracker: UserPlanTracker = useSelector(selector.userPlanTracker)

    const [searchText, setSearchText] = useState('')

    const handleClear = () => {
        setSearchText('')
        props.handleSearch('')
    }

    const handleChange = (value: string) => {
        setSearchText(value)
        props.handleSearch(value)
    }

    const handleButtonClick = (label: string) => {
        if (label === "NewMessage") {
            props.OnClickNewMessage()
        } else if (label === "GroupChat") {
            props.OnClickNewGroupMessage()
        } else {
            props.OnClickNewCampaignMessage()
        }
    }

    return (
        <div className={`b-none brl-1 w-fill mr-1 ml-2`} style={{ marginRight: "3px" }}>
            <div className='d-flex'>
                <FilledInput
                    inputProps={{
                        tabIndex: 4,
                        "data-arrow-index": 2000,
                    }}
                    value={searchText}
                    fullWidth
                    className="m-auto filled-search-input bg-color-conv-card-highlight h4-regular"
                    placeholder={"Search..."}
                    onChange={(e) => handleChange(e.target.value)}
                    startAdornment={<InputAdornment position="start">
                        <SearchIcon />
                    </InputAdornment>}
                    endAdornment={
                        searchText && (
                            <InputAdornment position="end">
                                <button
                                    className="d-flex c-pointer"
                                    onClick={handleClear}
                                >
                                    <SearchButtonClearIcon />
                                </button>
                            </InputAdornment>
                        )
                    }
                    disableUnderline
                />
                {!props.IsMobileDevice && !props.SecureChat &&
                    <>
                        <div className='d-flex '>
                            {(IsNewOrgFlow ? userPlanTracker?.HasGroupChat : PlanMetrics.HasAccessToGroupChat) && <Tooltip title="Group chat">
                                <button className="new-groupChat-button  ml-2 br-2 p-1 d-flex m-auto" onClick={props.OnClickNewGroupMessage} tabIndex={5}>
                                    {IsDarkMode ? <GroupChatGrey className='w-3 h-3' /> : <NewGroupChatMessageIcon className="m-auto w-3 h-3" />}
                                </button>
                            </Tooltip>}

                            <Tooltip title="New Message">
                                <button className="primary-btn ml-2 br-2 p-1 d-flex m-auto" onClick={props.OnClickNewMessage} tabIndex={6}>
                                    <NewMessageIcon2 className="m-auto w-3 h-3" />
                                </button>
                            </Tooltip>
                        </div>
                        {/* <CustomButtonGroup onButtonClick={handleButtonClick} openSendMessage={props.openSendMessage} /> */}
                    </>
                }
            </div>
        </div>)
}

export default ConversationHeader